(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cb-gemstone-hub"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.cb-gemstone-hub').forEach((hub)=>{const input=hub.querySelector('.cb-gemstone-hub__search input');const clear=hub.querySelector('.cb-gemstone-hub__search button');const status=hub.querySelector('.cb-gemstone-hub__search-status');const buttons=Array.from(hub.querySelectorAll('[data-cb-letter-button]'));const groups=Array.from(hub.querySelectorAll('[data-cb-letter-group]'));const entries=Array.from(hub.querySelectorAll('[data-cb-gemstone-entry]'));const searchPanel=hub.querySelector('[data-cb-search-results]');const searchList=searchPanel?.querySelector('ul');const searchCount=hub.querySelector('[data-cb-search-count]');const noResults=hub.querySelector('.cb-gemstone-hub__no-results');let activeLetter='';const normalize=(value)=>value.toLowerCase().replace(/[’']/g,'').trim();const setLetter=(letter)=>{activeLetter=letter;buttons.forEach((button)=>button.setAttribute('aria-selected',String(button.dataset.cbLetterButton===letter)));groups.forEach((group)=>group.hidden=group.dataset.cbLetterGroup!==letter);if(searchPanel)searchPanel.hidden=true;if(noResults)noResults.hidden=true};buttons.forEach((button)=>{const group=groups.find((item)=>item.dataset.cbLetterGroup===button.dataset.cbLetterButton);const hasEntries=Boolean(group?.querySelector('[data-cb-gemstone-entry]'));button.disabled=!hasEntries;if(hasEntries&&!activeLetter)activeLetter=button.dataset.cbLetterButton;button.addEventListener('click',()=>setLetter(button.dataset.cbLetterButton))});if(activeLetter)setLetter(activeLetter);const filterEntries=()=>{const query=normalize(input?.value||'');if(!query){if(searchPanel)searchPanel.hidden=true;if(noResults)noResults.hidden=true;if(status)status.textContent='';setLetter(activeLetter);clear.hidden=true;return}groups.forEach((group)=>group.hidden=true);buttons.forEach((button)=>button.setAttribute('aria-selected','false'));const matches=entries.filter((entry)=>normalize(entry.dataset.search||'').includes(query));if(searchList){searchList.innerHTML='';matches.forEach((entry)=>searchList.append(entry.cloneNode(true)))}if(searchPanel)searchPanel.hidden=matches.length===0;if(noResults)noResults.hidden=matches.length!==0;if(searchCount)searchCount.textContent=`${matches.length} ${matches.length===1?'gemstone':'gemstones'} found`;if(status)status.textContent=searchCount?.textContent||'';clear.hidden=false};input?.addEventListener('input',filterEntries);clear?.addEventListener('click',()=>{input.value='';filterEntries();input.focus()});});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
